import { CompanyTypeOption } from "../types";

export const invalidCompanyNumberLabel = "Please enter the Company Registration Number or Charity Number in the correct format";
export const invalidMailingPostCodeLabel = "Please enter a valid postcode for the mail address with a space in the middle";
export const invalidInvoicePostCodeLabel = "Please enter a valid postcode for the invoice address with a space in the middle";
export const invalidEmailAddressLabel = "Please enter a valid email address";
export const invalidBusinessPhoneLabel = "Please enter a valid UK telephone number";

export const companyNumberNotNeeded = (companyType: string) => {
    return companyType === CompanyTypeOption.SoleTrader ||  companyType === CompanyTypeOption.BusinessNotRegistered || companyType === CompanyTypeOption.LLP || companyType === CompanyTypeOption.Partnerships
}

